import {
  fromCondition,
  pipe,
  tapLeft,
  tapRight,
  fromBoolean,
} from "@otto-ec/assets-core-utils/nano-effect";
import { stack } from "../stack/global.svelte.js";
import {
  scopeInfo,
  statePropId,
  statePropOnLoad,
  statePropStack,
  type SheetNavScope,
} from "./scope.js";
import { navScope } from "./scope.js";
import { sheetTagName } from "../utils/consts.js";

const log = /*           */ navScope.scope("history-updater");

/**
 *
 *
 *
 *
 */
export const initHistoryHandling: (scope: SheetNavScope) => void = (scope) => {
  if (import.meta.env.DEV) log.info("init history updater integration", history.length);

  $effect(() => {
    if (import.meta.env.DEV) log.info("sheet stack changed", history.length);

    const currentId = scope.hash().get(sheetTagName);
    if (currentId === stack.current) {
      if (import.meta.env.DEV) log.info("already handled by fragment handler");
      return;
    }

    pipe(
      /*                                                                                              */
      /*                                                                              */
      /*                                                                              */

      /*                                                     */
      /*                                                             */
      fromCondition(stack.isPopping, stack.popLength, stack.current),

      /*                       */
      tapRight((entriesToRewind) => {
        /*                                                                       */
        if (entriesToRewind < 1) {
          if (import.meta.env.DEV) log.info("no entries to rewind, skip history rewind");
          return;
        }

        /*                                                                       */
        /*                                                              */
        if (!currentId) {
          if (import.meta.env.DEV) log.info("no sheet id in hash, skip history rewind");
          return;
        }

        /*                                               */
        scope.go(-entriesToRewind, scopeInfo);
      }),

      /*                                                                                     */
      tapLeft((newSheetId) => {
        /*                                                                                     */
        /*                                                                  */
        if (!newSheetId) {
          if (import.meta.env.DEV) log.info("no new sheet id, skip pushing to history");
          return;
        }

        /*                                                                          */
        if (currentId === newSheetId) {
          if (import.meta.env.DEV)
            log.info("sheet id", newSheetId, "is already in the hash, skip pushing");
          return;
        }

        /*                                                             */
        if (import.meta.env.DEV) log.info("new sheet id", newSheetId, "pushing to history");

        /*                              */
        const hash = scope.hash();
        const state = scope.state();

        pipe(
          fromBoolean(
            /*                                                                   */
            (state.get(statePropOnLoad) && !state.get(statePropId)) ||
              /*                                                 */
              state.get(statePropId) === newSheetId,
            /*                                               */
          ),

          /*                                                          */
          tapRight(() => {
            if (import.meta.env.DEV)
              log.info("updating state with new sheet id", newSheetId, history.length);

            state.set(statePropId, newSheetId);
            state.set(statePropStack, [...stack.prev]);
            scope.replace(scopeInfo);
          }),

          /*                                                     */
          tapLeft(() => {
            if (import.meta.env.DEV)
              log.info("pushing new history entry with new sheet id", newSheetId, history.length);

            hash.set(sheetTagName, newSheetId);
            scope.state({ [statePropStack]: [...stack.prev], [statePropId]: newSheetId });
            scope.push(scopeInfo);
          }),
        );
      }),
    );
  });
};
